import React, { useContext, useState, useEffect } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as actions from '../actions/actions';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/styles";
import MuiDialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import { List, ListItem, TextField } from "@material-ui/core";
import Service from "../services/service";

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const useStyles = makeStyles(() => ({
    popupButton: {
        justifyContent: "flex-end",
        borderTop: "1px solid #dddddd",
    },
    border: {
        borderStyle: "solid",
        height: "250px",
        borderRadius: "5px",
        borderColor: "#e6e6e6"
    },
    title: {
        padding: "10px 17px",
        borderBottom: "1px solid #dddddd",
    },
    contentData: {
        paddingBottom: "20px"
    },
    content: {
        padding: "10px 16px"
    },
    text_filed_container: {
        minWidth: "450px",
        borderRadius: "5px"
    },
    borderColor: {
        width: "100%",
        "& .MuiInput-underline:before": {
            borderBottom: "0px"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "0px"
        },
        "& .MuiInput-underline:not(.Mui-disabled):before": {
            borderBottom: "0px"
        },
    }
}));

export default function POPUP(props) {
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const dispatch = useContext(DispatchContext);
    const [name, setName] = useState('');
    const [nameTouched, setNameTouched] = useState(false);
    const [description, setDescription] = useState('');

    useEffect(() => {
    }, [])

    const submitButton = () => {
        setName(name.trim())
        if (!name.trim()) {
            setNameTouched(true);
            return false;
        }
        Service.CreateProject({ name: name, description: description }).then(res => {
            if (res.success) {
                dispatch(actions.notifyProjectsChanged());
                closeDialogBox();
                if (res.message === 'notificationMessage.projectCreated') {
                    dispatch(actions.openToast({ type: "success", message: s.notificationMessage.projectCreated, status: true }));
                }
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }

    const closeDialogBox = () => {
        dispatch(actions.create_project_popup(false));
    }

    return (
        <div>
            <Dialog maxWidth='sm' disableBackdropClick={false} aria-labelledby="customized-dialog-title" open={state.openCreateProjectPopup}>
                <DialogTitle className={classes.title}>
                    {s.newProject}
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <form className={classes.form} noValidate autoComplete="off">
                        <List>
                            <ListItem>
                                <div className={classes.text_filed_container}>
                                    <TextField
                                        required
                                        className={classes.text_filed_container}
                                        label={s.name}
                                        error={nameTouched && !name}
                                        size="small"
                                        value={name || ''}
                                        onFocus={(e) => setNameTouched(true)}
                                        onChange={(evt) => setName(evt.target.value)}
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                              ev.preventDefault();
                                              submitButton();
                                            }
                                        }}
                                    />
                                </div>
                            </ListItem>
                            <ListItem>
                                <div className={classes.text_filed_container}>
                                    <TextField
                                        multiline
                                        className={classes.text_filed_container}
                                        size="small"
                                        label={s.description}
                                        value={description || ""}
                                        onChange={(evt) => setDescription(evt.target.value)}
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                              ev.preventDefault();
                                              submitButton();
                                            }
                                        }}
                                    />
                                </div>
                            </ListItem>
                        </List>
                    </form>
                </DialogContent>
                <DialogActions className={classes.popupButton} >
                    <Button variant="contained" color="primary" onClick={submitButton}>
                        <span >{s.ok}</span>
                    </Button>
                    <Button variant="contained" color="primary" onClick={closeDialogBox}>
                        <span > {s.cancel} </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}